import { Platform, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { Link, type LinkProps } from 'expo-router'
import { ChevronLeft } from '@/src/assets/icons/ChevronLeft'
import { mesaColorNames, typography } from '@/src/common/theme'
import { triggerSegmentAction } from '@/src/services/segment'

interface BackButtonTrigger extends LinkProps {
  text?: string
  show?: boolean
  color?: string
}

export function BackButton({
  onPress,
  text,
  testID,
  show = Platform.OS !== 'web',
  color = mesaColorNames['Acre Turquoise/800 #086762'],
  ...props
}: BackButtonTrigger) {
  if (!show) return null

  return (
    <Link asChild dismissTo {...props}>
      <TouchableOpacity
        onPress={(event) => {
          void triggerSegmentAction({ component: 'Link', action: 'User Pressed Back Button' })
          onPress?.(event)
        }}
        testID={testID}
        style={{ flexDirection: 'row', alignItems: 'center' }}
      >
        <ChevronLeft size={24} style={styles.chevronLeft} color={color} />
        <Text style={[typography['heading/heading4'], { color }]}>{text}</Text>
      </TouchableOpacity>
    </Link>
  )
}

const styles = StyleSheet.create({
  chevronLeft: { marginRight: 16 },
})
